import React from "react";

import { type ChartData } from "chart.js";
import { Bar } from "react-chartjs-2";

import { Tooltip } from "@components/tooltip-container";
import { type MetricPrecision } from "@north-beam/nb-common/formatting";

import { getDerivedKpiChartOptions } from "./derived-kpi-chart-options";

type Props = {
  formatter: (value: number, precision?: MetricPrecision) => string;
  derivedActual: number;
  derivedBudgeted: number;
  dateRangeText: string;
};

export const DerivedKpiTileChart = ({
  formatter,
  derivedActual,
  derivedBudgeted,
  dateRangeText,
}: Props) => {
  const data: ChartData<"bar"> = {
    labels: [""],
    datasets: [
      {
        data: [derivedActual],
        borderColor: "#5CBF64",
        backgroundColor: "#5CBF64",
        barThickness: "flex",
      },
      {
        data: [derivedBudgeted],
        borderColor: "#7081FF",
        backgroundColor: "#7081FF",
        barThickness: "flex",
      },
    ],
  };

  return (
    <div className="flex-center flex-col space-y-1 w-full h-full">
      <div className="flex justify-between items-center w-full">
        <Tooltip
          noInfoCircle
          content={
            <div className="font-semibold">
              <div className="text-xs tracking-wide mb-1">ACTUAL TO DATE</div>
              <div className="text-gray+2 font-normal">{dateRangeText}</div>
              <div className="text-lg text-cosmic">
                {formatter(derivedActual, "exact")}
              </div>
            </div>
          }
        >
          <div className="text-xs tracking-wide flex items-center">
            <div className="h-3 w-3 rounded-sm bg-alien mr-1"></div>
            ACTUAL
          </div>
          <div className="text-xl font-semibold text-alien">
            {formatter(derivedActual)}
          </div>
        </Tooltip>
        <Tooltip
          noInfoCircle
          content={
            <div className="font-semibold">
              <div className="text-xs tracking-wide mb-1">
                FORECASTED TO DATE
              </div>
              <div className="text-gray+2 font-normal">{dateRangeText}</div>
              <div className="text-lg text-cosmic">
                {formatter(derivedBudgeted, "exact")}
              </div>
            </div>
          }
        >
          <div className="text-xs tracking-wide flex items-center">
            <div className="h-3 w-3 rounded-sm bg-cosmic mr-1"></div>
            FORECASTED
          </div>
          <div className="text-xl font-semibold text-cosmic">
            {formatter(derivedBudgeted)}
          </div>
        </Tooltip>
      </div>
      <div className="relative h-14 w-full">
        <Bar options={getDerivedKpiChartOptions(formatter)} data={data} />
      </div>
    </div>
  );
};
